import {
  Item,
  ItemContent,
  ItemDescription,
  ItemTitle,
  ItemTitleText,
  ItemTrigger,
} from 'designSystem/components/Item'
import type { BugReportAgentMode } from 'features/knowledgeDocumentViewer/utils/viewerBugReport'
import { useCallback } from 'react'

type BugReportAgentModeOptionProps = {
  value: BugReportAgentMode
  label: string
  description: string
  selected: boolean
  disabled?: boolean
  onSelect: (value: BugReportAgentMode) => void
}

export function BugReportAgentModeOption({
  value,
  label,
  description,
  selected,
  disabled = false,
  onSelect,
}: BugReportAgentModeOptionProps) {
  const handleClick = useCallback(() => {
    onSelect(value)
  }, [onSelect, value])

  return (
    <Item variant={selected ? 'surfaceActive' : 'outline'} disabled={disabled}>
      <ItemTrigger
        type='button'
        disabled={disabled}
        aria-pressed={selected}
        onClick={handleClick}>
        <ItemContent>
          <ItemTitle>
            <ItemTitleText>{label}</ItemTitleText>
          </ItemTitle>
          <ItemDescription>{description}</ItemDescription>
        </ItemContent>
      </ItemTrigger>
    </Item>
  )
}
